import moment from "moment";

const formatDate = (date, fromFormat, toFormat) =>
  !date ||
  !fromFormat ||
  !toFormat ||
  date.replace(" ", "").length !== fromFormat.length
    ? date
    : moment(date, fromFormat).format(toFormat);

export { formatDate };
